import { DropdownMenuComp } from "@/components/ui";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/shared/hooks/useAuth";
import { useAuthClient } from "@/shared/lib/authClient";
import { RoutesConfig } from "@/shared/lib/model/routes";
import { CircleUser } from "lucide-react";
import Link from "next/link";

export const UserMenu = () => {
	const client = useAuthClient();
	return (
		<DropdownMenuComp.DropdownMenu>
			<DropdownMenuComp.DropdownMenuTrigger asChild>
				<Button variant="outline" size="icon">
					<CircleUser className="h-5 w-5" />
					<span className="sr-only">Toggle user menu</span>
				</Button>
			</DropdownMenuComp.DropdownMenuTrigger>
			<DropdownMenuComp.DropdownMenuContent align="end">
				{/*<DropdownMenuComp.DropdownMenuLabel>My Account</DropdownMenuComp.DropdownMenuLabel>
				<DropdownMenuComp.DropdownMenuSeparator />
				<DropdownMenuComp.DropdownMenuItem>Settings</DropdownMenuComp.DropdownMenuItem>
				<DropdownMenuComp.DropdownMenuItem>Support</DropdownMenuComp.DropdownMenuItem>
				<DropdownMenuComp.DropdownMenuSeparator />*/}
				<DropdownMenuComp.DropdownMenuItem onSelect={() => client.signOut()}>
					Logout
				</DropdownMenuComp.DropdownMenuItem>
			</DropdownMenuComp.DropdownMenuContent>
		</DropdownMenuComp.DropdownMenu>
	);
};

export const HeaderButtons = () => {
	const session = useAuth();
	let buttons: React.ReactNode;

	if (session.status === "PENDING") {
		buttons = (
			<>
				<div className="w-12 h-2 rounded-full bg-accent animate-pulse" />
				<div className="w-12 h-2 rounded-full bg-accent animate-pulse" />
			</>
		);
	} else if (session.status === "AUTHENTICATED") {
		buttons = <UserMenu />;
	} else if (session.status === "UNAUTHENTICATED") {
		buttons = (
			<>
				<Button asChild={true} size={"sm"} variant={"secondary"}>
					<Link prefetch={false} href={RoutesConfig.signIn.path}>Sign in</Link>
				</Button>
				<Button asChild={true} size={"sm"}>
					<Link prefetch={false} href={RoutesConfig.signUp.path}>Sign Up</Link>
				</Button>
			</>
		);
	}

	return <div className="flex items-center gap-2">{buttons}</div>;
};
